module.exports = __webpack_public_path__ + "menu_1_active.5597bd73.png";